import React, { Component, PureComponent, useEffect, useState } from "react";
import Image from "react-bootstrap/Image";
import moment from "moment";
import { TotalNumberSmallDateRange } from "../reusableReports/TotalNumberSmallBox";
import { ReportsLiveChart } from "./charts/ReportsLiveChart";
import { Button, Col } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import SVG from "react-inlinesvg";
import axios from "axios";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { dinerLiveReport } from "../../../../store/actions/VendorReports/vendorReportsRestaurant";
import isEmpty from "../../../../store/validation/is-Empty";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Label } from "recharts";

import { ReportsStatus } from "./charts/ReportsStatus";
import { PieChart, Pie, Cell } from "recharts";
import { serverApi } from "../../../../config/Keys";
import { groupBy } from "../../../../function/groupBy";
const orderTypes = [
  "Takeaway",
  "Curbside",
  "Skip the Line",
  "Dine-In",
  "Buffet",
  "Catering",
  "Drivethru",
  "Homedelivery",
];

const eventColors = ["#3C307F", "#F77D22", "##24D9D9"];
const earningColors = [
  "#B380FC",
  "#B380FC",
  "#B380FC",
  "#E06C9E",
  "#6F32C9",
  "#2196F3",
  "#0A6162",
  "#890D43",
];

export class ReportsDashboardOne extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: null,
      reportType: this.props.reportType,
      settledAmount: null,
      earnings: null,
      eventStatus: [
        {
          name: "Active Ticket Booked",
          value: 0,
          pax: 0,
          color: "#3C307F",
        },
        {
          name: "Inactive Ticket Booked",
          value: 0,
          pax: 0,
          color: "#757575",
        },
        {
          name: "Active RSVP",
          value: 0,
          pax: 0,
          color: "#24D9D9",
        },
        {
          name: "Inactive RSVP",
          value: 0,
          pax: 0,
          color: "#F77D22",
        },
        {
          name: "Active Online Event",
          value: 0,
          pax: 0,
          color: "#118857",
        },
        {
          name: "Inactive Online Event",
          value: 0,
          pax: 0,
          color: "#8B1046",
        },
      ],
      eventType: null,
      eventEarnings: null,
      liveEvents: null,
      dateFrom: this.props.dateTo,
      dateTo: this.props.dateFrom,
    };
  }

  oneTimeReports = async () => {
    let settledAmount = await axios.get(`${serverApi}/event/reports`, {
      params: { settledAmount: true },
      headers: {
        Authorization: this.state.auth.user.accessToken,
        "Content-Type": "application/json",
      },
    });
    let liveData = await axios.get(`${serverApi}/event/reports`, {
      params: { live: true },
      headers: {
        Authorization: this.state.auth.user.accessToken,
        "Content-Type": "application/json",
      },
    });
    this.setState({
      settledAmount: settledAmount.data,
      liveEvents: liveData.data,
    });
  };

  getReports = async (type) => {
    let dateQuery = {};
    if (type === "custom") {
      dateQuery.from = this.props.dateFrom;
      dateQuery.to = this.props.dateTo;
    }
    let earnings = await axios.get(`${serverApi}/event/reports`, {
      params: { earnings: true, [type]: true, ...dateQuery },
      headers: {
        Authorization: this.state.auth.user.accessToken,
        "Content-Type": "application/json",
      },
    });
    let eventStatus = await axios.get(`${serverApi}/event/reports`, {
      params: { eventStatus: true, [type]: true, ...dateQuery },
      headers: {
        Authorization: this.state.auth.user.accessToken,
        "Content-Type": "application/json",
      },
    });
    let eventType = await axios.get(`${serverApi}/event/reports`, {
      params: { eventType: true, [type]: true, ...dateQuery },
      headers: {
        Authorization: this.state.auth.user.accessToken,
        "Content-Type": "application/json",
      },
    });
    let eventEarnings = await axios.get(`${serverApi}/event/reports`, {
      params: { eventEarnings: true, [type]: true, ...dateQuery },
      headers: {
        Authorization: this.state.auth.user.accessToken,
        "Content-Type": "application/json",
      },
    });

    this.setState({
      earnings: earnings?.data,
      eventType: this.groupReportData(eventType?.data),
      eventEarnings: this.groupEarningsData(eventEarnings?.data),
    });
    this.pieChartData(eventStatus?.data);
  };

  pieChartData = (data) => {
    let total = Object.keys(data).reduce(
      (sum, key) => sum + parseFloat(data[key] || 0),
      0
    );
    let pieChart = [
      {
        name: "Active Ticket Booked",
        value: data?.activeTicket ? (data?.activeTicket / total) * 100 : 0,
        pax: data?.activeTicket ? data?.activeTicket : 0,
        color: "#3C307F",
      },
      {
        name: "Inactive Ticket Booked",
        value: data?.inactiveTicket ? (data?.inactiveTicket / total) * 100 : 0,
        pax: data?.inactiveTicket ? data?.inactiveTicket : 0,
        color: "#757575",
      },
      {
        name: "Active RSVP",
        value: data?.activeRSVP ? (data?.activeRSVP / total) * 100 : 0,
        pax: data?.activeRSVP ? data?.activeRSVP : 0,
        color: "#24D9D9",
      },
      {
        name: "Inactive RSVP",
        value: data?.inactiveRSVP ? (data?.inactiveRSVP / total) * 100 : 0,
        pax: data?.inactiveRSVP ? data?.inactiveRSVP : 0,
        color: "#F77D22",
      },
      {
        name: "Active Online Event",
        value: data?.activeOnline ? (data?.activeOnline / total) * 100 : 0,
        pax: data?.activeOnline ? data?.activeOnline : 0,
        color: "#118857",
      },
      {
        name: "Inactive Online Event",
        value: data?.inactiveOnline ? (data?.inactiveOnline / total) * 100 : 0,
        pax: data?.inactiveOnline ? data?.inactiveOnline : 0,
        color: "#8B1046",
      },
    ];
    this.setState({ eventStatus: pieChart });
  };

  groupReportData = (data) => {
    let report = [];
    let date = null;
    data.forEach((ele) => {
      if (this.state.reportType === "hourly")
        date = `${moment(ele.date).format("m")} Mins`;
      if (this.state.reportType === "daily")
        date = moment(ele.date).format("h A");
      if (this.state.reportType === "weekly")
        date = moment(ele.date).format("ddd");
      if (this.state.reportType === "monthly")
        date = moment(ele.date).format("MMM");
      if (this.state.reportType === "custom")
        date = moment(ele.date).format("ll");
      let data = {
        date: date,
        eventType: ele.event_type,
        count: ele.count,
        type: ele.type,
      };
      report.push(data);
    });
    report = groupBy(report, "type");
    report = Object.keys(report).map((ele) => {
      let data = {};
      report[ele].forEach((e) => {
        data[e.eventType] = e.count;
      });
      return {
        name: report[ele][0].date,
        ...data,
      };
    });
    return report;
  };

  groupEarningsData = (data) => {
    let report = [];
    let date = null;
    data.forEach((ele) => {
      if (this.state.reportType === "hourly")
        date = `${moment(ele.date).format("m")} Mins`;
      if (this.state.reportType === "daily")
        date = moment(ele.date).format("h A");
      if (this.state.reportType === "weekly")
        date = moment(ele.date).format("ddd");
      if (this.state.reportType === "monthly")
        date = moment(ele.date).format("MMM");
      if (this.state.reportType === "custom")
        date = moment(ele.date).format("ll");
      let data = {
        date: date,
        eventType: ele.event_type,
        totalAmount: ele.totalEarnings,
        type: ele.type,
      };
      report.push(data);
    });
    report = groupBy(report, "type");
    report = Object.keys(report).map((ele) => {
      let data = {};
      report[ele].forEach((e) => {
        data[e.eventType] = e.totalAmount;
      });
      return {
        name: report[ele][0].date,
        ...data,
      };
    });
    return report;
  };

  componentDidMount() {
    this.getReports(this.props.reportType);
    this.oneTimeReports();
  }

  getdata = () => {
    this.props.dinerLiveReport(
      moment(this.props.dateFilter).format("x"),
      moment(this.props.dateTo).format("x"),
      moment(this.props.dateFrom).format("x")
    );
  };
  componentDidUpdate(prevProps) {
    if (
      prevProps.dateTo !== this.props.dateTo ||
      prevProps.dateFrom !== this.props.dateFrom
    ) {
      this.setState({
        dateTo: this.props.dateTo,
        dateFrom: this.props.dateFrom,
      });
      if (this.props.reportType === "custom") {
        this.getReports(this.props.reportType);
      }
    }
    if (prevProps.reportType !== this.props.reportType) {
      this.setState({ reportType: this.props.reportType });
      this.getReports(this.props.reportType);
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.auth) !== nextState.auth) {
      return {
        auth: nextProps.auth,
      };
    } else {
      return null;
    }
  }

  render() {
    const { liveEvents, hourlyReport, rangeReport, reportToDisp } = this.state;
    return (
      <React.Fragment>
        <div
          onClick={this.props.onClick}
          className="col-12 seating-report-dashboard-live"
        >
          <div className="row">
            <Col md={12} className="d-flex justify-content-between pb-4">
              <div className="f16-700">Active Events Report Live Dashboard</div>

              <div className="d-flex align-items-center">
                <div className="live-button-css">
                  <p className="live-text">Live</p>
                </div>
              </div>
              {/*<div className="d-flex align-items-end">
                 <p className="date-year-month">
                  {moment(new Date()).format("DD MMMM YYYY")}
                </p> 
              </div>*/}
            </Col>
            <Col lg={10}>
              <div>
                <ReportsLiveChart
                  iconImage={require("../../../../assets/images/UserManagement/walkin.svg")}
                  altText="Ticket Booked"
                  titleText="Ticket Booked"
                  imageClass="progress-bar-icon-imageone"
                  headingText="Ticket Booked"
                  tooltipTitle={`${
                    liveEvents?.activeTicket || 0
                  } Active events`}
                  paragraphText={`Total number of Completed Events out of ${
                    liveEvents && liveEvents?.activeTicket
                      ? `${(
                          (liveEvents?.activeTicket / liveEvents.total) *
                          100
                        ).toFixed(0)}%`
                      : `100%`
                  }`}
                  now={
                    liveEvents && liveEvents?.activeTicket
                      ? (liveEvents.activeTicket / liveEvents.total) * 100
                      : 0
                  }
                  progressBar="main-progress-bar-sectionsix"
                />
                <ReportsLiveChart
                  iconImage={require("../../../../assets/images/Icon/waitlist.png")}
                  altText="RSVP"
                  titleText="RSVP"
                  imageClass="progress-bar-icon-imagetwo"
                  headingText="RSVP"
                  tooltipTitle={`${liveEvents?.activeRSVP || 0} Active events`}
                  paragraphText={`Total number of Completed Events out of ${
                    liveEvents && liveEvents.activeRSVP
                      ? `${(
                          (liveEvents.activeRSVP / liveEvents.total) *
                          100
                        ).toFixed(0)}%`
                      : `100%`
                  }`}
                  now={
                    liveEvents && liveEvents.activeRSVP
                      ? (liveEvents.activeRSVP / liveEvents.total) * 100
                      : 0
                  }
                  progressBar="main-progress-bar-sectionseven"
                />
                <ReportsLiveChart
                  iconImage={require("../../../../assets/images/Icon/reservationBlack.png")}
                  altText="Online Event"
                  titleText="Online Event"
                  imageClass="progress-bar-icon-imagethree"
                  headingText="Online Event"
                  tooltipTitle={`${
                    liveEvents?.activeOnline || 0
                  } Active events`}
                  paragraphText={`Total number of Completed Events out of ${
                    liveEvents && liveEvents.activeOnline
                      ? `${(
                          (liveEvents.activeOnline / liveEvents.total) *
                          100
                        ).toFixed(0)}%`
                      : `100%`
                  }`}
                  now={
                    liveEvents && liveEvents.activeOnline
                      ? (liveEvents.activeOnline / liveEvents.total) * 100
                      : 0
                  }
                  progressBar="main-progress-bar-sectioneight"
                />
              </div>
            </Col>
            <Col lg={2}>
              <TotalNumberSmallBox
                mainBoxOne="reports-dashboard-small-boxtotal"
                displayBox="display-box-all"
                colorBoxOne="color-box-one color-3C307F"
                colorBoxTwo="color-box-one color-F77D22"
                colorBoxThree="color-box-one color-24D9D9"
                headingText="f10-400"
                valueText="f12-500 mt-2"
                walkinValue={0}
                waitlistValue={0}
                reservationValue={0}
              />
            </Col>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
            <div className="col-12 seating-report-hourly-day">
              <div className="row">
                <Col lg={5}>
                  <div className="f16-700 pb-4">
                    Active Events{" "}
                    {this?.props?.reportType.charAt(0).toUpperCase() +
                      this?.props?.reportType.slice(1) || "Hourly"}{" "}
                    Usage Report
                  </div>
                </Col>
                <Col
                  lg={7}
                  className="pb-4 d-flex justify-content-end align-items-center"
                >
                  {/* <button type="button" className="enIconBtnGray mr-3">
                    <SVG
                      src={require("../../../../assets/images/UserManagement/left-arrow.svg")}
                      alt="seating"
                    />
                  </button>
                  <TextField
                    type="date"
                    className="w-75"
                    variant="outlined"
                    value={this.props.dateFilter}
                    onChange={this.props.onDateChange}
                  />
                  <button type="button" className="enIconBtnGray ml-3">
                    <SVG
                      src={require("../../../../assets/images/UserManagement/right-arrow.svg")}
                      alt="seating"
                    />
                  </button> */}

                  <div className="f12-700">
                    {this.state.reportType === "hourly"
                      ? `Hourly - ${moment().format("ll")}`
                      : this.state.reportType === "daily"
                      ? `${moment().format("ll")}`
                      : this.state.reportType === "weekly"
                      ? `${moment()
                          .subtract(7, "days")
                          .format("ll")} - ${moment().format("ll")}`
                      : this.state.reportType === "monthly"
                      ? `${moment()
                          .subtract(365, "days")
                          .format("ll")} - ${moment().format("ll")}`
                      : this.state.reportType === "custom"
                      ? `${moment(new Date(this.props.dateFrom)).format(
                          "ll"
                        )} - ${moment(new Date(this.props.dateTo)).format(
                          "ll"
                        )}`
                      : ``}
                  </div>
                </Col>
                <div
                  onClick={this.props.onClick}
                  className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9"
                  style={{ cursor: "pointer" }}
                >
                  <ReportsStackedChart
                    data={this.state.eventType}
                    colors={eventColors}
                    xAxisTitle="Time Slot"
                    yAxisTitle="No of Events"
                  />
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
                  <div>
                    <p className="f10-700 mb-2">
                      {moment(new Date()).format("LT")}
                    </p>
                  </div>
                  <TotalNumberSmallBox
                    mainBoxOne="reports-dashboard-small-boxtotal"
                    displayBox="display-box-all"
                    colorBoxOne="color-box-one color-3C307F"
                    colorBoxTwo="color-box-one color-F77D22"
                    colorBoxThree="color-box-one color-24D9D9"
                    headingText="f10-400"
                    valueText="f12-500 mt-2"
                    ticketBooked={0}
                    rsvpValue={0}
                    onlineEventsValue={0}
                  />
                </div>
              </div>
            </div>
          </div>
          <Col lg={4}>
            <div className="col-12 seating-report-date-range">
              <div className="row">
                <Col md={8}>
                  <div className="f16-700 pb-4">Events Report</div>
                </Col>
                <Col md={4}>
                  <div className="f12-700">
                    {this.state.reportType === "hourly"
                      ? `Hourly - ${moment().format("ll")}`
                      : this.state.reportType === "daily"
                      ? `${moment().format("ll")}`
                      : this.state.reportType === "weekly"
                      ? `${moment()
                          .subtract(7, "days")
                          .format("ll")} - ${moment().format("ll")}`
                      : this.state.reportType === "monthly"
                      ? `${moment()
                          .subtract(365, "days")
                          .format("ll")} - ${moment().format("ll")}`
                      : this.state.reportType === "custom"
                      ? `${moment(new Date(this.props.dateFrom)).format(
                          "ll"
                        )} - ${moment(new Date(this.props.dateTo)).format(
                          "ll"
                        )}`
                      : ``}
                  </div>
                  <div className="f12-400">Reporting Date</div>
                </Col>
                {/* <Col md={6}>
                  <div className="f12-500 mb-1">Starts Date</div>
                  <TextField
                    type="date"
                    className="w-100"
                    variant="outlined"
                    value={this.props.dateFrom}
                    onChange={this.props.onFromDateChange}
                  />
                </Col>
                <Col md={6}>
                  <div className="f12-500 mb-1">Ends Date</div>
                  <TextField
                    type="date"
                    className="w-100"
                    variant="outlined"
                    value={this.props.dateTo}
                    onChange={this.props.onToDateChange}
                  />
                </Col> */}
              </div>
              <ReportsDonutChart data={this.state.eventStatus} />
            </div>
          </Col>
        </div>

        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
            <div className="col-12 seating-report-hourly-day">
              <div className="row">
                <Col lg={5}>
                  <div className="f16-700 pb-4">Total Earnings Report</div>
                </Col>
                <Col
                  lg={7}
                  className="pb-4 d-flex justify-content-end align-items-center"
                >
                  {/* <button type="button" className="enIconBtnGray mr-3">
                    <SVG
                      src={require("../../../../assets/images/UserManagement/left-arrow.svg")}
                      alt="seating"
                    />
                  </button>
                  <TextField
                    type="date"
                    className="w-75"
                    variant="outlined"
                    value={this.props.dateFilter}
                    onChange={this.props.onDateChange}
                  />
                  <button type="button" className="enIconBtnGray ml-3">
                    <SVG
                      src={require("../../../../assets/images/UserManagement/right-arrow.svg")}
                      alt="seating"
                    />
                  </button> */}
                  <div className="f12-700">
                    {this.state.reportType === "hourly"
                      ? `Hourly - ${moment().format("ll")}`
                      : this.state.reportType === "daily"
                      ? `${moment().format("ll")}`
                      : this.state.reportType === "weekly"
                      ? `${moment()
                          .subtract(7, "days")
                          .format("ll")} - ${moment().format("ll")}`
                      : this.state.reportType === "monthly"
                      ? `${moment()
                          .subtract(365, "days")
                          .format("ll")} - ${moment().format("ll")}`
                      : this.state.reportType === "custom"
                      ? ``
                      : ``}
                  </div>
                </Col>
                <div
                  onClick={this.props.onClick}
                  className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9"
                  style={{ cursor: "pointer" }}
                >
                  <ReportsStackedChart
                    data={this.state.eventEarnings}
                    colors={earningColors}
                    xAxisTitle="Time Slot"
                    yAxisTitle="Amount"
                  />
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
                  <div>
                    <p className="f10-700 mb-2">
                      {moment(new Date()).format("LT")}
                    </p>
                  </div>
                  <TotalNumberSmallBox
                    mainBoxOne="reports-dashboard-small-boxtotal"
                    displayBox="display-box-all"
                    colorBoxOne="color-box-one color-3C307F"
                    colorBoxTwo="color-box-one color-F77D22"
                    colorBoxThree="color-box-one color-24D9D9"
                    headingText="f10-400"
                    valueText="f12-500 mt-2"
                    walkinValue={0}
                    waitlistValue={0}
                    reservationValue={0}
                  />
                </div>
              </div>
            </div>
          </div>
          <Col lg={4}>
            <DailyEarnings
              reportType={this.state.reportType}
              earnings={this.state.earnings || []}
            />
            {this.state.settledAmount && (
              <DailyCumulativeAmount settlement={this.state.settledAmount} />
            )}
          </Col>
        </div>
      </React.Fragment>
    );
  }
}
const DailyCumulativeAmount = ({ settlement }) => {
  return (
    <div
      className="m-3 p-3"
      style={{
        background: "#FFFFFF 0% 0%",
        boxShadow: "0px 3px 6px #2121211F",
        borderRadius: "6px",
      }}
    >
      <div className="f14-500 mt-2">
        Cumulative Amount from last settlement till today
      </div>
      <div className="f14-400 mt-2">{`From ${moment(
        settlement?.settleAmount?.payoutEndDate
      ).format("ll")} till date`}</div>
      <div className="f24-700">{`₹ ${
        (settlement?.orderEarnings[0]?.totalAmount || 0)
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,") || 0
      }`}</div>

      <div className="f14-500 mt-2">Last Settlement Amount</div>
      <div className="f14-400 mt-2">
        {moment(settlement?.settleAmount?.createdAt).format("ll") || "-"}
      </div>
      <div className="f18-500 mt-2">{`₹ ${
        (settlement?.settleAmount?.settlement_amoun || 0)
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,") || 0
      }`}</div>
    </div>
  );
};

const DailyEarnings = ({ earnings, reportType }) => {
  let dateRange;
  let startTime;
  let endTime;
  if (reportType === "hourly") {
    dateRange = moment().format("ll");
    startTime = moment().subtract(1, "hour").format("h:m A");
    endTime = moment().format("h:m A");
  }
  if (reportType === "daily") {
    dateRange = moment().format("ll");
    startTime = moment().startOf("day").format("lll");
    endTime = moment().format("lll");
  }
  if (reportType === "weekly") {
    startTime = moment().subtract(7, "days").format("ll");
    endTime = moment().format("ll");
  }
  if (reportType === "monthly") {
    startTime = moment().subtract(365, "days").format("ll");
    endTime = moment().format("ll");
  }
  return (
    <div
      className="m-3 p-3"
      style={{
        background: "#FFFFFF 0% 0%",
        boxShadow: "0px 3px 6px #2121211F",
        borderRadius: "6px",
      }}
    >
      <div className="f14-500 mt-2">Earnings in Events for</div>
      <div className="f14-700 mt-2">{dateRange}</div>
      <div className="f18-700 mt-2" style={{ color: "#EE3A23" }}>
        {!isEmpty(earnings)
          ? `₹ ${(earnings[0]?.totalAmount)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`
          : "₹ 0.00"}
      </div>
      <div className="mt-2 mb-2">
        <div class="progress" style={{ height: "8px" }}>
          <div
            class="progress-bar"
            role="progressbar"
            style={{ backgroundColor: "#EE3A23", width: "75%", height: "8px" }}
            aria-valuenow="0"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center">
        <div className="f10-400" style={{ color: "#9E9E9E" }}>
          {`From ${startTime}`}
        </div>
        <div className="f10-400" style={{ color: "#9E9E9E" }}>
          {`To ${endTime}`}
        </div>
      </div>
    </div>
  );
};

class ReportsDonutChart extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data,
      COLORS: [
        "#3C307F",
        "#757575",
        "#24D9D9",
        "#F77D22",
        "#118857",
        "#8B1046",
      ],
      STROKE: ["#fff", "#fff", "#fff", "#fff", "#fff", "#fff"],
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (nextProps.data !== nextState.data) {
      return {
        data: nextProps.data,
      };
    }
  }
  render() {
    return (
      <React.Fragment>
        <div className="row main-donut-pie-chart">
          <div className="col-lg-12 d-flex align-items-center justify-content-center">
            <div className="dount-chart-circle">
              <PieChart width={200} height={200} onMouseEnter={this.onPieEnter}>
                <Pie
                  data={this.state.data}
                  cx={80}
                  cy={80}
                  innerRadius={62}
                  outerRadius={80}
                  fill="#8884d8"
                  stroke="#8884d8"
                  strokeWidth={2}
                  paddingAngle={0}
                >
                  {this.state.data.map((entry, index) => (
                    <Cell
                      key={index}
                      fill={this.state.COLORS[index % this.state.COLORS.length]}
                      stroke={
                        this.state.STROKE[index % this.state.STROKE.length]
                      }
                    />
                  ))}
                  <Tooltip />
                </Pie>
              </PieChart>
            </div>
          </div>
          <div className="col-lg-12 mt-4">
            <div className="row">
              {this.state.data.map((data) => {
                return (
                  <div className="col-lg-4">
                    <ReportsStatus
                      colorBox={`color-box ${data.color}`}
                      paratext={data.name}
                      value={data.pax ? data.pax : 0}
                      color={data.color}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
// export default ReportsDashboardOne;
const TotalNumberSmallBox = ({
  mainBoxOne,
  displayBox,
  colorBoxOne,
  colorBoxTwo,
  colorBoxThree,
  headingText,
  valueText,
  ticketBooked,
  rsvpValue,
  onlineEventsValue,
}) => {
  return (
    <React.Fragment>
      <div className={mainBoxOne}>
        <div className="p-3 border-bottom">
          <div className={displayBox}>
            <div className={colorBoxOne}></div>
            <h5 className={headingText}>Ticket Booked</h5>
          </div>
          {ticketBooked && (
            <div className="f10-400">{ticketBooked} Users Booked Event</div>
          )}
          {/* <div className="col-12 pl-1">
            <h3 className={valueText}>{walkinValue} pax</h3>
          </div> */}
        </div>
        <div className="p-3 border-bottom">
          <div className={displayBox}>
            <div className={colorBoxTwo}></div>
            <h5 className={headingText}>RSVP</h5>
          </div>
          {rsvpValue && (
            <div className="f10-400">{rsvpValue} Users Booked Event</div>
          )}
          {/* <div className="col-12 pl-1">
            <h3 className={valueText}>{waitlistValue} pax</h3>
          </div> */}
        </div>
        <div className="p-3">
          <div className={displayBox}>
            <div className={colorBoxThree}></div>
            <h5 className={headingText}>Online Event</h5>
          </div>
          {onlineEventsValue && (
            <div className="f10-400">
              {onlineEventsValue} Users Booked Event
            </div>
          )}
          {/* <div className="col-12 pl-1">
            <h3 className={valueText}>{reservationValue} pax</h3>
          </div> */}
        </div>
      </div>
    </React.Fragment>
  );
};

const ReportsStackedChart = ({ data, colors, xAxisTitle, yAxisTitle }) => {
  const [reportData, setReportData] = useState([
    {
      name: "11am",
      waitlist: 20,
      reservation: 12,
      walkin: 10,
    },
  ]);

  useEffect(() => {
    if (!isEmpty(data)) {
      setReportData(data);
    } else {
      setReportData([]);
    }
  }, [data]);
  return (
    <React.Fragment>
      <div className="stacked-chart-content">
        <BarChart
          width={600}
          height={292}
          data={reportData.map((data) => {
            return data;
          })}
          margin={{ top: 0, right: 0, left: 0, bottom: 10 }}
        >
          <XAxis
            dataKey="name"
            stroke="#707070"
            fontSize="8"
            fontFamily="Roboto-Medium"
          >
            <Label
              value={xAxisTitle}
              offset={-10}
              position="insideBottom"
              fontSize={13}
              fontFamily="Roboto-Regular"
            />
          </XAxis>
          <YAxis
            stroke="#707070"
            fontSize={13}
            fontFamily="Roboto-Regular"
            label={{
              value: yAxisTitle,
              angle: -90,
              position: "insideLeft",
              offset: 15,
            }}
          />
          <Tooltip />
          {/* <Legend /> */}
          <Bar
            dataKey="Ticket Booked"
            barSize={12}
            stackId="a"
            fill={colors[0]}
            strokeWidthTop={2}
            stroke={"#fff"}
            radius={[1, 1, 1, 1]}
          />
          <Bar
            dataKey="RSVP"
            barSize={12}
            stackId="a"
            fill={colors[1]}
            strokeWidthTop={2}
            stroke={"#fff"}
            radius={[1, 1, 1, 1]}
          />
          <Bar
            dataKey="Online Event"
            barSize={12}
            stackId="a"
            fill={colors[2]}
            strokeWidthTop={2}
            stroke={"#fff"}
            radius={[1, 1, 1, 1]}
          />
        </BarChart>
      </div>
    </React.Fragment>
  );
};

ReportsDashboardOne.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, { dinerLiveReport })(
  withRouter(ReportsDashboardOne)
);
